
import subscriptionConstants from '@/constants/subscription.constants';

const { subscribeProductKeys, subscriptionPlans } = subscriptionConstants;

export default {
    name: 'FinAgentNavigationButton',

    computed: {
        isLoggedIn() {
            return !!this.$store.state.account.user
        }, 
        finAgentAvatar() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-answer-avatar-dark.svg') :
                require('@/assets/icons/fin-agent-answer-avatar-light.svg');
        },
        isSubscribedFinAgent() {
            return this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
        navigationDisabled() {
            return !this.isSubscribedFinAgent && this.$route.name === this.$getTranslatedRouteName('subscription');
        }
    },

    methods: {
        getFinAgentLink() {
            if (this.isSubscribedFinAgent) {
                return {
                    path: this.$getTranslatedRoutePath('/fin-agent/'),
                };
            }

            if (this.navigationDisabled) {
                return '';
            }

            return {
                name: this.$getTranslatedRouteName('subscription'),
                params: { plan: subscriptionPlans.ai }
            };
        },
        handleClickFinAgent() {
            if (this.navigationDisabled) {
                this.$store.commit('snackbar/updateType', 'error');
                this.$store.commit('snackbar/updateMessage', this.$t('component.searchbar.subscriptionRequired'));
                return;
            }

            this.$router.push(this.getFinAgentLink());
        },
    },
}
